/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: branding-service
 *
 * Created by rwilliams on 8/4/17.
 */

'use strict';

angular.module('prism-ui.components.branding').service('BrandingViewService',
    function (
        _,
        $q,
        AcceptProfileResourceFactory,
        ArtworkResourceFactory,
        BrandingAssetService,
        BreadcrumbService,
        BreakPrePostRollResourceFactory,
        ContentEditService,
        ContentResourceFactory,
        DebugService,
        MediaProfileResourceFactory,
        ModalService,
        NetworkResourceFactory,
        NotificationService,
        PermissionsService,
        PrePostRollResourceFactory,
        RequestService
    ) {

        var self = this;

        self.initializeParentBreadcrumbs = (brandingConfig, params) => {
            let breadcrumbDataPromises = [];
            let newBreadcrumbs = [{
                location: brandingConfig.parentLocation,
                params: 'view=' + brandingConfig.type,
            }];

            if (brandingConfig.isShow) {
                breadcrumbDataPromises.push(ContentResourceFactory.get({id: params.id, view: 'MINIMAL'}).$promise);
                if (brandingConfig.seasonId) {
                    breadcrumbDataPromises.push(ContentResourceFactory.getSeason({id: brandingConfig.seasonId, view: 'MINIMAL'}).$promise);
                    newBreadcrumbs.splice(0, 0, {
                        location: brandingConfig.parentLocation.replace(/\/seasons\/.+/, '/seasons'),
                    });
                } else if (brandingConfig.volumeId) {
                    breadcrumbDataPromises.push(ContentResourceFactory.getVolume({id: brandingConfig.volumeId, view: 'MINIMAL'}).$promise);
                    newBreadcrumbs.splice(0, 0, {
                        location: brandingConfig.parentLocation.replace(/\/volumes\/.+/, '/volumes'),
                    });
                }
            } else {
                breadcrumbDataPromises.push(NetworkResourceFactory.get({id: params.id, view: 'MINIMAL'}).$promise);
            }

            return $q.all(breadcrumbDataPromises).then((breadcrumbsData) => {
                return _.map(breadcrumbsData, (breadcrumbData, index) => {
                    let parentBreadcrumb = _.get(BreadcrumbService.getBreadcrumbs(), index +1);
                    if (!parentBreadcrumb) {
                        parentBreadcrumb = newBreadcrumbs[index];
                        parentBreadcrumb.name = breadcrumbData.name;
                        BreadcrumbService.addBreadcrumb(parentBreadcrumb);
                    }
                    return parentBreadcrumb;
                });
            });
        };

        self.getMediaAcceptProfiles = () => {
            var queryParam = {
                fetchLimit: 0,
                view: 'NORMAL'
            };

            return AcceptProfileResourceFactory.query(queryParam).$promise;
        };

        var permissionViewStates = {
            // TODO: All branding use same permission
            networks: {
                preRolls: 'NETWORK_PREROLL_SEARCH_VIEW_STATE',
                postRolls: 'NETWORK_POSTROLL_SEARCH_VIEW_STATE',
                breakPrePostRolls: 'NETWORK_BREAKPREPOSTROLL_SEARCH_VIEW_STATE',
                watermarks: 'NETWORK_WATERMARK_SEARCH_VIEW_STATE',
                artwork: 'NETWORK_ARTWORK_SEARCH_VIEW_STATE'
            },
            series: {
                preRolls: 'SERIES_PREROLL_SEARCH_VIEW_STATE',
                postRolls: 'SERIES_POSTROLL_SEARCH_VIEW_STATE',
                breakPrePostRolls: 'SERIES_PREROLL_SEARCH_VIEW_STATE',
                watermarks: 'SERIES_WATERMARK_SEARCH_VIEW_STATE',
                artwork: 'SERIES_ARTWORK_SEARCH_VIEW_STATE'
            },
            movies: {
                preRolls: 'MOVIE_PREROLL_SEARCH_VIEW_STATE',
                postRolls: 'MOVIE_POSTROLL_SEARCH_VIEW_STATE',
                breakPrePostRolls: 'MOVIE_PREROLL_SEARCH_VIEW_STATE',
                watermarks: 'MOVIE_WATERMARK_SEARCH_VIEW_STATE',
                artwork: 'MOVIE_ARTWORK_SEARCH_VIEW_STATE'
            }
        };

        self.getReadWritePermissions = (brandingConfig) => {
            let permissionViewState = permissionViewStates[brandingConfig.groupName][brandingConfig.type];
            return PermissionsService.getReadWritePermissions(permissionViewState);
        };


        //===========================//
        // Branding Asset Containers //
        //===========================//

        const acceptProfileKey = (assetType) => {
            switch (assetType) {
                case 'watermarks':
                    return 'videoAcceptProfile';
                case 'ratingOverlays':
                    return 'mediaAcceptProfile';
                default:
                    return 'acceptProfile';
            }
        };


        //=================//
        // Branding Assets //
        //=================//

        self.openAssetPreviewModal = (asset, assetType) => {
            if (assetType === 'ratingOverlay') {
                asset = _.assign({type: 'ratingOverlay'}, asset);
            }
            ModalService.showMediaModal(assetType, asset);
        };

        var assetInfoModalTemplateUrls = {
            cc: 'components/branding/renderers/audio-text-info-renderer-template.html',
            audio: 'components/branding/renderers/audio-text-info-renderer-template.html',
            artwork: 'components/branding/renderers/image-info-renderer-template.html',
            watermark: 'components/branding/renderers/image-info-renderer-template.html',
            ratingOverlay: 'components/branding/renderers/image-info-renderer-template.html',
        };
        self.openAssetInfoModal = (asset, assetType) => {
            let templateUrl = _.get(assetInfoModalTemplateUrls, assetType, `components/branding/renderers/${assetType}-info-renderer-template.html`);
            switch (assetType) {
                case 'cc':
                case 'audio':
                    ModalService.showAssetModal(asset, templateUrl, assetType);
                    break;
                case 'ratingOverlay':
                    ModalService.showAssetModal(_.assign({type: 'ratingOverlay'}, asset), templateUrl);
                    break;
                default:
                    ModalService.showAssetModal(asset, templateUrl);
            }
        };

        self.showVideoIngestStatusNotifications = (brandingConfig, videoAsset, status, mapPrefix) => {
            let acceptProfile = videoAsset[acceptProfileKey(brandingConfig.type)];
            switch (status) {
                case 'COMPLETED':
                    NotificationService.createInfoNotification(
                        `Proxy COMPLETED for MAP ${mapPrefix}${acceptProfile.name}`
                    );
                    break;
                case 'STALLED':
                    NotificationService.createWarningNotification(
                        `Proxy STALLED for MAP ${mapPrefix}${acceptProfile.name}`
                    );
                    break;
                default:
            }
        };

        self.createRootAssetProxyNotifications = (brandingConfig, rootAsset) => {
            let intervalId;
            let deferred = $q.defer();
            let acceptProfile = rootAsset[acceptProfileKey(brandingConfig.type)];
            NotificationService.createInfoNotification(`Creating Proxy for MAP ${acceptProfile.name}`);

            let intervalData = {};
            intervalId = RequestService.createRequestInterval(() => {
                return BrandingAssetService.updateVideoAssetProxyStatus(brandingConfig, rootAsset, intervalData)
                    .then((status) => {
                        switch (status) {
                            case 'COMPLETED':
                                RequestService.cancelRequestInterval(intervalId);
                                deferred.resolve();
                                break;
                            case 'STALLED':
                                RequestService.cancelRequestInterval(intervalId);
                                deferred.reject('Failed to create proxy');
                                break;
                        }
                    });
            }, 2000);
            return deferred.promise;
        };
    });
